/* eslint-disable no-return-await */
import React, { useEffect, useState, useRef } from 'react';
import { Form } from '@unform/web';
import Swal from 'sweetalert2';
import { FaEllipsisH, FaTrash } from 'react-icons/fa';
import {
  Button,
  Card,
  Col,
  Row,
  Table,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from 'reactstrap';
import { toast } from 'react-toastify';
import { Input } from '../../components/unform/index';
import api from '../../services/api';
import { Translator } from '../../components/i18n';

const swalWithBootstrapButtons = Swal.mixin({
  customClass: {
    confirmButton: 'ml-3 btn btn-success',
    cancelButton: 'btn btn-danger',
  },
  buttonsStyling: false,
});

function PlugField() {
  const obrigatorio = Translator({
    path: 'obrigatorio',
  });
  const dadosSalvosSucesso = Translator({
    path: 'dadosSalvosSucesso',
  });
  const erroSalvarDados = Translator({
    path: 'erroSalvarDados',
  });
  const erro = Translator({
    path: 'erro',
  });
  const operacaoNaorevertida = Translator({
    path: 'operacaoNaorevertida',
  });
  const temcertezaExcluirPlugField = Translator({
    path: 'temcertezaExcluirPlugField',
  });
  const sim = Translator({
    path: 'sim',
  });
  const nao = Translator({
    path: 'nao',
  });
  const sucesso = Translator({
    path: 'sucesso',
  });
  const formRef = useRef();

  const [dispositivos, setDispositivos] = useState([]);
  const [modal, setModal] = useState(false);

  const toggle = () => setModal(!modal);

  async function getDispositivos() {
    Swal.fire({
      allowOutsideClick: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    const { data } = await api.get('/plugfield');

    setDispositivos(data);
    window.scrollTo(0, 0);

    Swal.close();
  }

  useEffect(() => {
    getDispositivos();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSubmitDispositivo = async (data) => {
    const errors = {};

    Object.keys(data).forEach((f) => {
      if (!data[f]) {
        errors[f] = obrigatorio;
      }
    });

    formRef.current.setErrors(errors);

    if (!Object.keys(errors).length) {
      Swal.fire({
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
      try {
        await api.post('/plugfield', data);

        toast.success(dadosSalvosSucesso);
        toggle();
        getDispositivos();
        Swal.close();
      } catch (err) {
        toast.error(err?.response?.data?.error || erroSalvarDados);
        Swal.close();
      }
    }
  };

  const handleDelete = async (id) => {
    swalWithBootstrapButtons
      .fire({
        title: temcertezaExcluirPlugField,
        text: operacaoNaorevertida,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: sim,
        cancelButtonText: nao,
        reverseButtons: true,
      })
      .then(async (result) => {
        if (result.value) {
          try {
            await api.delete(`/plugfield/${id}`);
            getDispositivos();
            Swal.close();
            toast.success(sucesso);
          } catch (er) {
            toast.error(erro);
          }
        }
      });
  };

  return (
    <>
      <Row>
        <Col>
          <h4 className="mb-3">
            <Translator path="plugfield.label" />
          </h4>
        </Col>
      </Row>
      <Card>
        <div className="p-3 justify-content-between d-flex align-items-center">
          <Col lg={6}>
            <h6 className="txt-muted">
              <Translator path="excecoes.totalregistros" />{' '}
              {dispositivos?.total}
            </h6>
          </Col>
          <Col />
          <div className="d-flex justify-content-center">
            <Button
              onClick={() => toggle()}
              type="button"
              className="btn btn-primary ml-3"
            >
              <Translator path="plugfield.btnnovo" />
            </Button>
          </div>
          <div className="d-flex justify-content-center" />
        </div>

        <Table responsive>
          <thead>
            <tr>
              <th>
                <Translator path="plugfield.nome" />
              </th>
              <th>
                <Translator path="plugfield.id" />
              </th>
              <th className="text-left">
                <Translator path="plugfield.acao" />
              </th>
            </tr>
          </thead>
          <tbody>
            {dispositivos?.dispositivos?.length ? (
              dispositivos?.dispositivos?.map((c) => (
                <tr key={c?.id}>
                  <td>{c?.nome}</td>
                  <td>{c?.serial}</td>
                  <td className="text-left">
                    <UncontrolledDropdown
                      size="xs"
                      style={{ position: 'absolute' }}
                    >
                      <DropdownToggle color="link link-gray" size="xs">
                        <FaEllipsisH size="1.3em" color="#43b02a" />
                      </DropdownToggle>
                      <DropdownMenu right>
                        <DropdownItem
                          size="xs"
                          onClick={() => handleDelete(c?.id)}
                        >
                          <FaTrash className="mr-1" size={18} />
                          <Translator path="plugfield.acao.delete" />
                        </DropdownItem>
                      </DropdownMenu>
                    </UncontrolledDropdown>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td>
                  <Translator path="excecoes.semregistros" />
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </Card>

      <Modal isOpen={modal} toggle={toggle} size="sm">
        <ModalHeader toggle={toggle}>
          <Translator path="plugfield.novodevice.label" />
        </ModalHeader>
        <Form ref={formRef} onSubmit={(data) => handleSubmitDispositivo(data)}>
          <ModalBody>
            <Row>
              <Col lg={12}>
                <Input
                  name="chave_acesso"
                  label={<Translator path="plugfield.novodevice.chaveacesso" />}
                  className="form-control"
                  type="text"
                />
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button color="success" type="submit">
              <Translator path="botao.salvar" />
            </Button>
          </ModalFooter>
        </Form>
      </Modal>
    </>
  );
}

export default PlugField;
